// Zuletzt-verwendet-Speicher (Backlog D3): pro User ueber die generische user_preferences-Route
// persistiert (cross-device, ueberlebt den Mock-Reset — Nutzungshistorie ist Portal-Daten, keine
// SAP-Daten). Eintraege sind kleine ANZEIGE-Kopien der Auswahl (id + Beschriftung), KEINE
// Stammdaten-Quelle: die Wahrheit kommt weiterhin aus der Suche/dem Adapter. Neueste zuerst,
// dedupliziert je id, gedeckelt auf MAX. Alle Fehler degradieren still (leere Liste/kein Persist).
import { getPreference, setPreference } from './api';

const MAX = 10;
// user_preferences erlaubt nur [a-z0-9_-] im Key (keine Punkte).
const KEYS = {
  equipment: 'pm-recent-equipment',
  materials: 'pm-recent-materials',
};

/**
 * Liste der zuletzt verwendeten Eintraege (neueste zuerst), [] bei Fehler/leer.
 * @param {Object} user
 * @param {'equipment'|'materials'} kind
 */
export async function getRecent(user, kind) {
  try {
    const res = await getPreference(user, KEYS[kind]);
    return Array.isArray(res?.value) ? res.value : [];
  } catch {
    return [];
  }
}

/**
 * Verwendung verbuchen: Eintrag nach vorn, Duplikat (gleiche id) raus, auf MAX kappen.
 * Fire-and-forget-tauglich — Aufrufer muessen nicht warten, Fehler bleiben still.
 * @param {Object} user
 * @param {'equipment'|'materials'} kind
 * @param {Object} entry — Anzeige-Kopie (z. B. {equipmentId, description, functionalLocation, plant})
 * @param {string} idField — Feldname der id ('equipmentId' | 'materialId')
 */
export async function recordRecent(user, kind, entry, idField) {
  try {
    const list = await getRecent(user, kind);
    const next = [entry, ...list.filter((e) => e && e[idField] !== entry[idField])].slice(0, MAX);
    await setPreference(user, KEYS[kind], next);
  } catch {
    /* still — Recency ist Komfort, nie blockierend */
  }
}
